import { Injectable } from '@angular/core';
import { ReplaySubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class GoogleMapsLoaderService {
  private loaded = false;
  private loadPromise: Promise<void> | null = null;
  private loadedSubject = new ReplaySubject<boolean>(1);

  loaded$ = this.loadedSubject.asObservable();

  load(apiKey: string): Promise<void> {
    if (this.loaded) {
      return Promise.resolve();
    }
    if (this.loadPromise) {
      return this.loadPromise;
    }

    const existingScript = document.querySelector(
      'script[src*="maps.googleapis.com"]'
    );
    if (existingScript) {
      this.loaded = true;
      this.loadedSubject.next(true);
      return Promise.resolve();
    }

    this.loadPromise = new Promise<void>((resolve, reject) => {
      const script = document.createElement('script');
      script.src = `https://maps.googleapis.com/maps/api/js?key=${encodeURIComponent(apiKey)}`;
      script.async = true;
      script.onload = () => {
        this.loaded = true;
        this.loadedSubject.next(true);
        resolve();
      };
      script.onerror = () => {
        this.loadPromise = null;
        reject(new Error('Google Maps script failed to load'));
      };
      document.head.appendChild(script);
    });

    return this.loadPromise;
  }

  isLoaded(): boolean {
    return this.loaded;
  }
}
